import { themeColors } from "../../config";
export const WebViewStyles = {
  frame: {
    backgroundColor: themeColors.transparentWhite,
    border: "2px solid white",
  },
};
